import { colorPalette } from "@/themes/colorPalette";
import { alpha } from "@mui/material";
export const shades = {
  Primary: {
    main: colorPalette.Primary,
    100: "#EAF5EE",
    200: "#D4ECDE",
    300: "#BFE2CD",
    400: "#A9D9BD",
    500: "#94CFAC",
    600: "#7EC69C",
    700: "#69BC8B",
    800: "#53B37B",
    900: "#47A06C",
    1000: "#3E8A5D",
    1100: "#34754F",
    1200: "#2B5F40",
    1300: "#1B3C28",
    1400: "#142E1F",
  },
  Secondary: {
    main: colorPalette.Secondary,
    100: "#fffcfa",
    200: "#fff9f4",
    300: "#fff5ed",
    400: "#ffeeda",
    500: "#ffe9d5",
    600: "#ffd9c0",
    700: "#ffc5aa",
    800: "#ffab94",
    900: "#ff9987",
    1000: "#ff8869",
    1100: "#ff774b",
    1200: "#ff6632",
    1300: "#ff5519",
    1400: "#ff4300",
  },
  Success: {
    main: colorPalette.Success,
    100: "#DDF9E7",
    200: "#dcfce7",
    300: "#bbf7d0",
    400: "#86efac",
    500: "#4ade80",
    600: "#22c55e",
    700: "#16a34a",
    800: "#15803d",
    900: "#166534",
    1000: "#14532d",
    1100: "#13411a",
    1200: "#122e16",
    1300: "#111b12",
    1400: "#101210",
  },
  Info: {
    main: colorPalette.Info,
    100: "#ecfeff",
    200: "#cffafe",
    300: "#a5f3fc",
    400: "#67e8f9",
    500: "#22d3ee",
    600: "#06b6d4",
    700: "#0891b2",
    800: "#0e7490",
    900: "#155e75",
    1000: "#164e63",
    1100: "#173f59",
    1200: "#182f4e",
    1300: "#191f43",
    1400: "#1a1e39",
  },
  Warning: {
    main: colorPalette.Warning,
    100: "#FDEFD6",
    200: "#fef3c7",
    300: "#fde68a",
    400: "#fcd34d",
    500: "#fbbf24",
    600: "#f59e0b",
    700: "#eab308",
    800: "#ca8a04",
    900: "#a16207",
    1000: "#854d0e",
    1100: "#713f12",
    1200: "#5c2e13",
    1300: "#481a0e",
    1400: "#311407",
  },
  Error: {
    main: colorPalette.Error,
    100: "#fcdada",
    200: "#fed7d7",
    300: "#feb2b2",
    400: "#fc8181",
    500: "#f56565",
    600: "#e53e3e",
    700: "#c53030",
    800: "#9b2c2c",
    900: "#742a2a",
    1000: "#641212",
    1100: "#520b0b",
    1200: "#400000",
    1300: "#2d0000",
    1400: "#190000",
  },
  Neutrals: {
    main: colorPalette.Neutral,
    100: "#FFFFFF",
    200: "#D8D8D8",
    300: "#E5E5E5",
    400: "#D4D4D4",
    500: "#A3A3A3",
    600: "#737373",
    700: "#868080",
    800: "#404040",
    900: "#645f5e",
    1000: "#000000",
    1100: "#413D3D",
    1200: "#000000",
    1300: "#1F1D1D",
    1400: "#000000",
  },
  action: {
    selected: alpha("#737373", 0.16),
    disabled: alpha("#737373", 0.8),
    disabledBackground: alpha("#737373", 0.24),
    focus: alpha("#737373", 0.24),
  },
};